function updateMathContent() {
    setTimeout(function() {
        var math = MathJax.Hub.getAllJax("mathdiv")[0];
        MathJax.Hub.Queue(["Typeset", MathJax.Hub, math]);
    }, 1000);
}